import { Component, Input, Output, EventEmitter } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
    selector: 'app-wizard-step',
    templateUrl: './wizard-step.component.html',
    styleUrls: ['./wizard-step.component.scss']
})
export class WizardStepComponent {
    @Input() title: string;
    @Input() stepIndex = 1;
    @Input() lastStepIndex = 5;
    @Input() stepSubTitle: string;
    @Input() nextButtonText = 'Next';
    @Input() nextButton2Text = 'SEND TO CANDIDATE';
    @Input() isLoading = new BehaviorSubject<boolean>(true);
    @Input() isNextButton2Enabled = false;
    @Output() previousStepClicked = new EventEmitter();
    @Output() nextStepClicked = new EventEmitter();
    @Output() nextStep2Clicked = new EventEmitter();

    goToPreviousStep(): void {
        this.previousStepClicked.emit();
    }

    goToNextStep(): void {
        this.nextStepClicked.emit();
    }

    goToNextStep2(): void {
        this.nextStep2Clicked.emit();
    }
}
